import { createConfig, fallback, http } from 'wagmi';
import { Chain, base, blast, monadTestnet } from 'wagmi/chains';

import { abcWagmi } from '@/configs/wagmi/abc';
import { gelatoWagmi } from '@/configs/wagmi/gelato';
import { injected } from 'wagmi/connectors';
import { binanceConnectorFN } from '../binance';
import { coinbaseWalletConnectorFN } from '../coinbase';
import { walletConnectConnectorFN } from '../walletConnectV2';

export const wagmiChains: Chain[] = [base, gelatoWagmi, abcWagmi, monadTestnet, blast];

export const wagmiConfig = createConfig({
  chains: [wagmiChains[0], ...wagmiChains.slice(1)],
  transports: {
    [base.id]: fallback([http()]),
    [gelatoWagmi.id]: fallback([http()]),
    [abcWagmi.id]: fallback([http()]),
    [monadTestnet.id]: fallback([http()]),
    [blast.id]: fallback([http()]),
  },
  connectors: [
    injected(),
    binanceConnectorFN(),
    walletConnectConnectorFN,
    // // burrito,
    // okxConnectorFN,
    coinbaseWalletConnectorFN,
    // bitkeepConnectorFN,
    // trustConnectorFN,
    // coin98ConnectorFN,
  ],
  // cacheTime: 0,
  // multiInjectedProviderDiscovery: false,
});

declare module 'wagmi' {
  interface Register {
    config: typeof wagmiConfig;
  }
}
